<button
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  [attr.aria-label]="ariaLabel"
  [attr.aria-describedby]="ariaDescribedBy"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-pressed]="ariaPressed"
  [attr.aria-disabled]="disabled || loading"
  (click)="onClick()"
  (keydown)="onKeydown($event)"
>
  @if (loading) {
    <span class="spinner" aria-hidden="true"></span>
  }
  <ng-content></ng-content>
</button>